import React from 'react';
import { AssignmentDisplayData } from 'types/assignment';

type Props = Pick<AssignmentDisplayData, 'condominumImplant'>;

export const CondominiumImplantData: React.FC<Props> = ({
  condominumImplant: { impiantoDescrizione, impiantoUbicazione }
}) =>
  impiantoDescrizione ? (
    <div className="row no-gutters">
      <div className="col-12 mb-lg-3">
        <p className="caption font__grey tran-uppercase">impianto/Ubicazione</p>
        <div className="d-flex align-items-end ">
          <p>{impiantoDescrizione}</p>
          {impiantoUbicazione && <p className="caption font__grey pl-2">({impiantoUbicazione})</p>}
        </div>
      </div>
    </div>
  ) : null;
